import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cwt-simple-page',
  templateUrl: './simple-page.component.html',
  styleUrls: ['./simple-page.component.less']
})
export class SimplePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
